import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import MessageHistoryList from '../components/organisms/MessageHistoryList'

const MessageHistory: React.FC<RouteComponentProps<{ kaiin_no: string }>> = ({ match }) => {
  // ページをロードした瞬間の初期クエリストリング
  return <MessageHistoryList kaiinNo={match.params.kaiin_no} />
}

export default MessageHistory
